<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <programa-editar-form @success="success"></programa-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <programa-editar-form @success="success"></programa-editar-form>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'programa-editar-form': require('./ProgramaEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
